export default __webpack_public_path__ + "static/media/sana.e55ad306.jpg";